<template>
  <div class="imgMin">
    <div v-loading="loading" :element-loading-text="loadingTxt">
      <div class="top-box">
        <p class="title">自动压缩图片</p>
        <form
          class="upload"
          id="form"
          method="post"
          enctype="multipart/form-data"
          :action="uploadUrl"
        >
          <div class="upload-dragger" id="dragger">
            <input
              type="file"
              name="files"
              id="f"
              multiple
              class="upload-input"
              accept="image/png, image/jpeg"
              @change="handleChange($event)"
            />
            <i class="el-icon-plus" />
            <span class="upload__text"
              >上传图片 或 拖拽本地图片至此处（支持png、jpg）</span
            >
          </div>
        </form>
      </div>
      <div class="op-box">
        <div class="head">
          <img src="../../assets/images/imgMin/headicon.png" />
          <p>学科网图片压缩工具</p>
        </div>
        <div class="op-top">
          <div class="op-slider">
            <span class="demonstration">压缩质量</span>
            <el-slider
              class="slider"
              v-model="minPers"
              @change="doCompress"
              :min="0"
              :max="100"
            ></el-slider>
          </div>
          <p class="ttips">数字越大越清晰，体积越大。</p>
        </div>
        <div class="op-content" v-if="compressList.length">
          <div
            class="min-item compressed-item"
            v-for="item in compressList"
            :key="item.uid"
          >
            <el-row>
              <el-col :span="12">{{ item.filename }}</el-col>
              <el-col :span="6"
                >压缩前：{{
                  item["size-before"] ? item["size-before"] + "kb" : "--kb"
                }}</el-col
              >
              <el-col :span="4" style="color: #ff3600"
                >压缩后：<span>{{
                  item["size-after"] ? item["size-after"] + "kb" : "--kb"
                }}</span></el-col
              >
            </el-row>
          </div>
        </div>
        <div class="wrapper__steps" v-else>
          <Steps />
        </div>
        <div class="op-bottom">
          <el-button
            type="primary"
            round
            @click="downLoad"
            :disabled="downLoading || uploading || !files.length"
            :loading="downLoading || uploading"
            >下载图片</el-button
          >
          <!-- <el-button
            type="primary"
            round
            @click="downLoad"
            :disabled="downLoading || !compressList.length"
            :loading="downLoading"
            >{{ downLoading ? '下载中' : `开始下载` }}</el-button
          > -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import Steps from "./components/Steps.vue";
import { downImgmin } from "@/assets/scripts/utils.js";
import api from "@/assets/scripts/api";
import http from "@/plugins/http";
export default {
  name: "ImgMin",
  data() {
    return {
      minPers: 80,
      loadingTxt: "",
      uploadUrl: api.compress,
      downLoading: false,
      uploading: false,
      resUrl: "",
      files: [],
      fileList: [],
      compressList: [],
    };
  },
  components: {
    Steps,
  },
  computed: {
    loading() {
      return this.downLoading || this.uploading;
    },
  },
  mounted() {
    let _this = this;
    const dragBox = document.querySelector("#dragger");
    dragBox.addEventListener("dragenter", dragEnter, false);
    dragBox.addEventListener("dragover", dragOver, false);
    dragBox.addEventListener("drop", drop, false);
    function dragEnter(e) {
      e.stopPropagation();
      e.preventDefault();
    }
    function dragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    }
    function drop(e) {
      // e.stopPropagation();
      e.preventDefault();
      _this.files = e.dataTransfer.files;
      _this.handleChange();
      // 当文件拖拽到dragBox区域时,可以在该事件取到files
    }
  },
  methods: {
    ...mapMutations(["updategenerateSuccess"]),
    // 图片添加
    handleChange(e) {
      this.compressList = [];
      this.files = (e && e.target.files) || this.files;
      for (let f of this.files) {
        this.compressList.push({
          filename: f.name,
          "size-before": Math.round(f.size / 1000),
          uid: f.name,
        });
      }
      this.doCompress();
    },
    // 开始压缩
    doCompress() {
      // 注释掉下面一行，压缩过程中可以保持图片名称列表的显示
      // this.compressList = [];
      if (!this.files.length) {
        return;
      }
      this.uploading = true;
      this.loadingTxt = "压缩中...";
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        formData.append("file", this.files[i]);
      }
      http
        .post(`${this.uploadUrl}?quality=${this.minPers}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res && res.code === 10000) {
            this.compressList = res.data.sizeInfo;
            this.resUrl = res.data.result;
          } else {
            this.$message.error(res.message);
          }
          this.uploading = false;
          // this.downLoad();
        });
    },
    // 开始下载
    async downLoad() {
      this.downLoading = true;
      this.loadingTxt = "下载中...";
      await downImgmin(this.resUrl);
      this.downLoading = false;
      this.$message.success("下载成功");
    },
  },
};
</script>
<style lang="scss">
.imgMin {
  height: 100%;
  .top-box {
    background: url("../../assets/images/imgMin/1.png") center center no-repeat;
    height: 512px;
    .title {
      font-family: Alibaba-PuHuiTi-B;
      font-size: 36px;
      color: #0005a8;
      letter-spacing: 0;
      text-align: center;
      line-height: 36px;
      font-weight: 700;
      padding-bottom: 36px;
      padding-top: 90px;
    }
    .upload {
      margin: 0 auto;
      padding: 8px;
      width: 464px;
      height: 278px;
      background: rgba(255, 255, 255, 0.8);
      border: 3px solid rgba(255, 255, 255, 1);
      box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 1);
      box-shadow: 0px 20px 50px 0px rgba(0, 59, 122, 0.2);
      border-radius: 20px;
      &:hover {
        background: rgba(255, 255, 255, 0.6);
        border: 3px solid rgba(255, 255, 255, 1);
        box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 1);
        box-shadow: 0px 20px 50px 0px rgba(0, 59, 122, 0.2);
        border-radius: 20px;
      }
      .upload-dragger {
        background: transparent;
        width: 464px;
        height: 278px;
        border: 1px dashed rgba(26, 31, 181, 1);
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .upload-input {
          opacity: 0;
          position: absolute;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        .upload__text {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #16007a;
          letter-spacing: 0;
          text-align: center;
          line-height: 21px;
          font-weight: 400;
          display: inline-block;
          width: 206px;
        }
        .el-icon-plus {
          margin-bottom: 22px;
          &::before {
            font-weight: bold;
            font-size: 36px;
            color: #1a1fb5;
            // border-radius: 2px;
          }
        }
      }
    }
  }
  .op-box {
    overflow: hidden;
    box-sizing: border-box;
    width: 1200px;
    background: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(2, 0, 109, 0.06);
    border-radius: 12px;
    margin: 0 auto;
    margin-top: 40px;
    padding: 36px 41px 40px 36px;
    .head {
      position: absolute;
      top: 10px;
      margin-left: -36px;
      display: flex;
      padding-top: 17px;
      img {
        width: 36px;
        height: 33px;
        margin-right: 8px;
      }
      p {
        font-family: Alibaba-PuHuiTi-B;
        font-size: 20px;
        color: #1a1fb5;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 700;
        margin-top: 6px;
      }
    }
    .demonstration {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 600;
    }
    .slider {
      position: relative;
      float: right;
      padding-right: 40px;
      padding-left: 26px;
      width: 940px;
      transform: translateY(-8px);
      .el-slider__button {
        background: #1a1fb5;
        border: 1px solid rgba(255, 255, 255, 1);
        height: 14px;
        width: 14px;
      }
      .el-slider__runway {
        height: 4px;
        margin: 0;
        margin-top: 16px;
      }
      .el-slider__bar {
        height: 4px;
        background: #1a1fb5;
        border-radius: 20px;
      }
      &::before {
        content: "0";
        position: absolute;
        left: -12px;
        top: 10px;
      }
      &::after {
        content: "100";
        position: absolute;
        right: 2px;
        top: 10px;
      }
      &::before,
      &::after {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
      }
    }
    .ttips {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
      margin-bottom: 20px;
      letter-spacing: 0;
      line-height: 14px;
      font-weight: 400;
    }
  }
  .op-top {
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 26px;
  }
  .op-bottom {
    text-align: center;
    margin-top: 40px;
    .el-button {
      width: 144px;
      height: 48px;
      background: #1a1fb5;
      border: 1px solid rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 10px 0px rgba(2, 0, 109, 0.2);
      font-size: 18px;
      border-radius: 16px;
      &:hover {
        background: #010693;
      }
    }
    button.el-button.el-button--primary.is-disabled.is-round {
      background: #d2d2d2;
      border: 1px solid rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 10px 0px rgba(2, 0, 109, 0.1);
      border-radius: 16px;
    }
  }
  .op-content {
    .min-item {
      padding: 28px 36px;
      background: #f6f6f6;
      border-radius: 20px;
      margin-bottom: 10px;
      .el-row {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 400;
      }
      &.compressed-item {
        background: #e8f0ff;
      }
    }
  }
  .el-loading-mask {
    background: transparent;
    .el-loading-spinner {
      .path,
      .el-loading-text {
        stroke: #1a1fb5;
        color: #1a1fb5;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-avtive {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
